<div class="dynamic-form" [ngSwitch]="activePage">
    <div *ngSwitchCase="PAGES.MAIN_START">
        <div class="modal-body">
            <cm-dynamic-form-content-details [contentDetails]="modalDetails"></cm-dynamic-form-content-details>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" (click)="dismissModal()">CLOSE</button>
            <button
                type="button"
                [disabled]="step?._userActionsDisabled"
                class="btn btn-primary"
                (click)="openFormPage()"
            >
                COMPLETE NOW
            </button>
        </div>
    </div>
    <div *ngSwitchCase="PAGES.EVIDENCE_CONFIRM">
        <div class="modal-body"><cm-confirm-info [info]="uploadInfo"></cm-confirm-info></div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" (click)="backToPreviousPage()">BACK</button>
            <button type="button" class="btn btn-primary" (click)="uploadFiles()">CONFIRM</button>
        </div>
    </div>
    <div *ngSwitchCase="PAGES.EVIDENCE_COMPLETE">
        <div class="modal-body">
            <div class="uploaded">
                <p class="uploaded__label">Document(s) uploaded</p>
                <cm-files-list class="uploaded__list" [files]="files"></cm-files-list>
                <cm-display-html class="details-description" [content]="step.description"></cm-display-html>
            </div>
        </div>
        <div class="modal-footer">
            <button
                *ngIf="isPendingVerificationStatus"
                type="button"
                class="btn btn-default"
                (click)="goToPage(PAGES.RESET_CONFIRM)"
            >
                RESET
            </button>
            <button type="button" class="btn btn-default" (click)="dismissModal()">CLOSE</button>
        </div>
    </div>
    <cm-reset-confirm-content
        *ngSwitchCase="PAGES.RESET_CONFIRM"
        (cancel)="backToPreviousPage()"
        (confirm)="onResetConfirm()"
    >
    </cm-reset-confirm-content>
    <ng-container *ngSwitchCase="PAGES.FORM_START">
        <cm-dynamic-form-content-sequence
            *ngIf="isSequentialView"
            [modalDetails]="modalDetails"
            [formData]="formData[0]?.formValue"
            [elements]="isStepSubmitted ? dynamicForms[0]?.fields : formInfo.fields"
            (screenChange)="onScreenChange($event)"
            (formSubmit)="onFormSubmit($event)"
            (formDismiss)="dismissModal()"
            [sections]="sections"
            [showFromStart]="isSequentialFromStart"
            [isFirstPage]="formPageFirst"
            [disabled]="step?._userActionsDisabled"
        >
        </cm-dynamic-form-content-sequence>
        <cm-dynamic-form-content
            *ngIf="!isSequentialView"
            [modalDetails]="modalDetails"
            [formData]="formData[0]?.formValue"
            [elements]="isStepSubmitted ? dynamicForms[0]?.fields : formInfo.fields"
            [isStepSubmitted]="isStepSubmitted"
            [isResetEnabled]="isPendingVerificationStatus"
            [signatureLink]="signature_link"
            (screenChange)="onScreenChange($event)"
            (formSubmit)="onFormSubmit($event)"
            [sections]="sections"
            [workflowTypeId]="workflowTypeId"
            [isFirstPage]="formPageFirst"
            [disabled]="step?._userActionsDisabled"
        >
        </cm-dynamic-form-content>
    </ng-container>

    <cm-multiple-dynamic-form-content
        *ngIf="activePage === PAGES.FORM_MULTIPLE_COMPLETE || simulateMultipleForm"
        [templateFormFields]="formInfo?.fields"
        [dynamicForms]="dynamicForms"
        [formValues]="formData"
        [ngClass]="{ simulateMultipleForm: simulateMultipleForm }"
        [isResetEnabled]="isPendingVerificationStatus"
        (screenChange)="onScreenChange($event)"
        (formSubmit)="onMultipleFormSubmit($event)"
        [previewMode]="isStepSubmitted"
        [modalDetails]="modalDetails"
        [signatureLink]="signature_link"
        [sections]="sections"
    >
    </cm-multiple-dynamic-form-content>
    <cm-draft-forms-content
        *ngSwitchCase="PAGES.DRAFT"
        (formSubmit)="saveMultipleFormFromDraft()"
        [formQuantity]="formData?.length || step.content.forms?.length"
        (screenChange)="onScreenChange($event)"
        [disabled]="step._userActionsDisabled"
        [details]="modalDetails"
    >
    </cm-draft-forms-content>
    <cm-form-confirm-content
        *ngSwitchCase="PAGES.FORM_CONFIRM"
        [step]="step"
        (screenChange)="onScreenChange($event)"
        (confirm)="onFormConfirm()"
    >
    </cm-form-confirm-content>
    <cm-signature-content
        *ngSwitchCase="PAGES.SIGNATURE"
        [step]="step"
        (screenChange)="onScreenChange($event)"
        (signatureSubmit)="onSignatureSubmit($event)"
    >
    </cm-signature-content>
</div>
